function injectStyle (ssrContext) {
  require("!!../../../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2ebbf478\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MentoringFooterItem.vue")
}
var Component = require("!../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MentoringFooterItem.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2ebbf478\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MentoringFooterItem.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ebbf478",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/modules/mentoring/teamcard/components/item/MentoringFooterItem.vue
// module id = 16444d1287b50b5317ef
// module chunks = 89